import React, { useEffect } from "react";
import styles from "../careersPage/careersPage.module.scss";
import Careers from "../../components/careers/Careers";
import Career from "../../components/career/Career";
import Navbar from "../../components/navbar/Navbar";
import AboutUs from "../../components/about/AboutUs";
import Contact from "../../components/contact/Contact";
import Footer from "../footer/Footer";
import ServerMegamPage from "../serverMegamPage/ServerMegamPage";
import WorkWithUs from "../../components/workWithUs/WorkWithUs";
import { useLocation } from "react-router-dom";

const CareersPage = () => {

  useEffect(() => {
    const section = document.getElementById("careerTop");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const section = document.getElementById(location.state.scrollTo);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div className={styles.container}>
      <Navbar />
      <Career id="careerTop" />
      <WorkWithUs />
      <AboutUs id="about" />
      <Contact id="contact" />
      <ServerMegamPage />
      <Footer />
    </div>
  );
};

export default CareersPage;
